import { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName, PageSection, PageSectionFace } from 'ui/components'
import { Button, IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { SarEdit } from '~bank-bsa-reporting/types'

import { emptySAR } from '../../../../../../../constants'
import { SubjectInformationItem } from './SubjectInformationItem'
import { s } from './SubjectInformationItem/styles'

export const SubjectInformationForm = () => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo`
  })

  const [itemToRemove, setItemToRemove] = useState<number | null>(null)

  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => itemToRemove !== null && remove(itemToRemove),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <PageSection face={PageSectionFace.THIRD} title="Step 3. Subject Information" anchor="step3">
      {fields.map((field, index) => (
        <s.Item
          rounded
          shadowed
          key={field.id}
          collapsible={false}
          title={`Edit Part I Subject Information ${+index + 1} of ${fields.length}`}
          actions={
            fields.length > 1 && (
              <IconButton
                face="negative"
                icon={IconName.DELETE}
                onClick={() => {
                  setItemToRemove(index)
                  startDeleting()
                }}
              >
                Remove
              </IconButton>
            )
          }
        >
          <SubjectInformationItem index={index} />
        </s.Item>
      ))}

      <Confirmation />

      <Button
        face="primary"
        onClick={() => {
          append(emptySAR.subjectsInfo[0])
        }}
      >
        add
      </Button>
    </PageSection>
  )
}
